import { Link } from "react-router-dom";
import { useLenis } from "lenis/react";
import { useLanguage } from "@/App";
import { translations } from "@/i18n";

const Footer = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const lenis = useLenis();

  const go = (id) => {
    if (lenis) lenis.scrollTo(id, { offset: -72 });
    else document.querySelector(id)?.scrollIntoView({ behavior: "smooth" });
  };

  const links = [
    ["#services", t.nav.services, "footer-services-link"],
    ["#why-nevada", t.nav.why, "footer-why-link"],
    ["#how-we-help", t.nav.process, "footer-process-link"],
    ["#about", t.nav.about, "footer-about-link"],
    ["#contact", t.nav.contact, "footer-contact-link"],
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#0A1128]">
      <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10">
        <div className="grid gap-14 md:grid-cols-12">
          <div className="md:col-span-5">
            <img
              src="/koam-logo.png"
              alt="KOAM Las Vegas Business Consultants LLC logo"
              className="h-28 w-auto rounded-sm"
            />
            <p className="mt-6 max-w-sm font-display text-lg font-light italic text-white/60">
              "{t.footer.tagline}"
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37]">{t.footer.explore}</p>
            <div className="mt-6 flex flex-col gap-3">
              {links.map(([id, label, testId]) => (
                <button
                  key={id}
                  data-testid={testId}
                  onClick={() => go(id)}
                  className="gold-underline self-start pb-0.5 text-sm font-light text-white/60 transition-colors duration-300 hover:text-white"
                >
                  {label}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="text-[11px] uppercase tracking-[0.35em] text-[#D4AF37]">{t.footer.contact}</p>
            <div className="mt-6 space-y-3 text-sm font-light text-white/60">
              <a
                data-testid="footer-email-link"
                href="mailto:hello@koamnv.com"
                className="block transition-colors duration-300 hover:text-[#D4AF37]"
              >
                hello@koamnv.com
              </a>
              <p>Las Vegas, Nevada, USA</p>
              <p>KOAMNV.com</p>
              <Link
                data-testid="footer-admin-link"
                to="/admin"
                className="inline-block pt-2 text-xs text-white/30 transition-colors duration-300 hover:text-white/70"
              >
                {t.footer.admin}
              </Link>
            </div>
          </div>
        </div>

        <div className="tricolor-line mt-16 w-full opacity-70" />
        <div className="flex flex-col items-start justify-between gap-4 pt-8 sm:flex-row sm:items-center">
          <p className="text-xs font-light text-white/40">{t.footer.rights}</p>
          <span className="font-kr text-xs text-white/25">한국과 미국을 잇다 · Connecting Korea & America</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
